import { gql } from 'apollo-angular';

export const GET_WORKER_COUNTING_ANALYTICS = gql`
  query GetWorkerCountingAnalytics(
    $filter: DtoEquipmentCountingJournalMetricsFilter
    $sortBy: String
    $limit: Int
  ) {
    getWorkerCountingAnalytics(
      filter: $filter
      sortBy: $sortBy
      limit: $limit
    ) {
      countedBy
      countedByName
      locationNum
      totalLines
      countedLines
      completionPercentage
      waitingCountLines
      notFoundLines
      addedLines
    }
  }
`;

export interface WorkerCountingAnalytics {
  countedBy: string;
  countedByName: string;
  locationNum?: string;
  totalLines: number;
  countedLines: number;
  completionPercentage: number;
  waitingCountLines: number;
  notFoundLines: number;
  addedLines: number;
}

export interface GetWorkerCountingAnalyticsResponse {
  getWorkerCountingAnalytics: WorkerCountingAnalytics[];
}
